import { Component, Input, OnChanges } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject } from 'rxjs';

@Component({
    selector: 'app-vis-detail',
    templateUrl: './vis-detail.component.html',
    styleUrls: ['../vis.component.css']
})
export class VisDetailComponent implements OnChanges {
    @Input() detailedData;
    @Input() detailedLegendTitle;
    @Input() sgtinFromDefaultView;
    
    detailedGraph;
    autoZoom;
    panningEnabled;
    zoomLevel;
    update$: Subject<any> = new Subject();
    center$: Subject<any> = new Subject();
    zoomToFit$: Subject<any> = new Subject();

    updateGraph() {
        this.update$.next(true);
    }
    
    centerGraph() {
        this.center$.next(true);
    }

    fitGraph() {
        this.zoomToFit$.next(true);
    }

    onZoomChange($event) {
        // console.log($event);
        this.zoomLevel = $event;
        // console.log(this.zoomLevel);
    }

    onZoomIn() {
        if (this.zoomLevel != 1) {
            this.autoZoom = false;
            this.panningEnabled = true;
            this.zoomLevel = 1;
            // console.log(this.zoomLevel);
        }
    }

    onZoomOut() {
        this.autoZoom = true;
        this.panningEnabled = false;
        // console.log(this.zoomLevel);
    }

    reloadCurrentPage(){
        let currentUrl = this.router.url;
        this.router.navigateByUrl('/', {skipLocationChange: true}).then(() => {
        this.router.navigate([currentUrl]);
        });
    }

    routeToSgtin(sgtin) {
        // console.log(sgtin);
        this.router.navigateByUrl('/', {skipLocationChange: true}).then(() => {
            this.router.navigate(['/vis', {sgtin: sgtin}]);
        });
    }

    showDetailGraph(data) {
        this.autoZoom = true;
        this.panningEnabled = false;
        this.detailedGraph = {
            nodes: [],
            links: []
        }
        for (let i = 0; i < data.length; i++) {
            let d = data[i];
            let childEPCs;
            let parentId;
            if (d.eventType == 'AggregationEvent') {
                parentId = d.parentID;
                childEPCs = d.childEpcList.join(", ");
            }
            let epcList;
            let source;
            let desti;
            if (d.eventType == 'TransactionEvent') {
                epcList = d.epcList.join(", ");
                source = d.source;
                desti = d.destination;
            }
            if (d.eventType == 'ObjectEvent') {
                epcList = d.epcList.join(", ");
            }
            let bizLocation;
            if (d.bizLocation != null) {
                bizLocation = d.bizLocation;
            }
            let bizStep;
            if (d.bizStep) {
                let stepChunks = d.bizStep.split(":");
                bizStep = stepChunks[stepChunks.length - 1];
            }
            let bizLocationName;
            if (d.bizLocationName != null) {
                bizLocationName = d.bizLocationName;
            }

            // let pos = d.any["http://ns．example．com/epcis#location"].coordinates;
            let loc : string  = d.geoLocation.split('^geoPoint')[0];
            let pos = loc.replace(' ', '').split(',');
            // let eventTime = new Date(d.eventTime.$date);
            this.detailedGraph.nodes.push({
                id: d.eventID,
                eventTime: d.eventTime,
                action: d.action,
                label: "",
                type: d.eventType,
                bizStep: bizStep,
                parentId: parentId,
                childEPCs: childEPCs,
                bizLocation: bizLocation,
                bizLocationName: bizLocationName,
                inputEPCList: d.inputList,
                outputEPCList: d.outputList,
                EPCList: epcList,
                source: source,
                destination: desti,
                lat: parseFloat(pos[0]),
                lng: parseFloat(pos[1])
            })
            if (this.detailedGraph.nodes.length > 1) {
                // console.log(this.detailedGraph.nodes);
                this.detailedGraph.links.push({
                  label: "",
                  source: this.detailedGraph.nodes[i-1].id,
                  target: d.eventID
                })
            }
          };
          // console.log(this.detailedGraph);
          this.updateGraph();
          this.centerGraph();
          this.fitGraph();
    }
      
    constructor(private route: ActivatedRoute, private router: Router) {}

    ngOnChanges(): void {
        // console.log(this.detailedData);
        this.showDetailGraph(this.detailedData);
    }
}